import { render, staticRenderFns } from "./MeetingPresence.vue?vue&type=template&id=38b12bc6&"
import script from "./MeetingPresence.vue?vue&type=script&lang=js&"
export * from "./MeetingPresence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports